import { axiosChartInstance } from "config";
import { useAxiosMutation } from "hooks";
import { useQueryClient } from "react-query";
import { ProgressFavoriteRequest } from "./useAddProgressFavorite";

function useUpdateProgressFavorite(id: string) {
  const queryClient = useQueryClient();

  return useAxiosMutation(
    ["updateProgressFavorite"],
    (payload: ProgressFavoriteRequest) =>
      axiosChartInstance.put(`v1/chart-progress-favorite/${id}`, payload),
    {
      onSuccess: () => {
        queryClient.invalidateQueries(["progressFavorites"]);
      },
    }
  );
}

export { useUpdateProgressFavorite };
